export default "__VITE_ASSET__DkkSM2Pm__"